import * as STD from '@emersya/mpa-std';
import * as CM from '@emersya/mpa-components-manager';
import {Image, Text} from '@emersya/mpa-components';

export interface IApplicationHeaderComponentConfiguration extends CM.DOMComponent.IConfiguration {
};

export class ApplicationHeaderComponent extends CM.DOMComponent<
	HTMLDivElement,
	ApplicationHeaderComponent,
	IApplicationHeaderComponentConfiguration
> {

	component_DOM: HTMLDivElement;

	static override initialize() {
		super.initialize();
	};

	override async component_initialize() {
		await super.component_initialize();
		const isFullWidth = this.component_DOM.classList.contains('fullWidth') ? true : false;
		document.body.dataset.headerPosition = this.component_parent?.id === 'visualization' ? 'viewer' : isFullWidth ? 'fullWidth' : 'menu';
	};

	override async component_start(ev: STD.events.Event<any, any>) {
		await super.component_start(ev);
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IApplicationHeaderComponentConfiguration
	) {
		configuration['@innerConfigurations'] = {
			logo: <Image.Configuration>{
				'@translations': {
					name: {
						en: 'logo header',
						fr: 'logo header'
					}
				},
				URL: app.clientAppParameters.app.assetsPath + app.getLogoFileName()
			},
			productName: <Text.Configuration>{
				'@translations': {
					text: {
						en: '',
						fr: ''
					}
				}
			}
		};
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement>STD.DOM.factory({
			tag: 'div'
		});
	};
};
export namespace NS {
	export const Component = ApplicationHeaderComponent;
	export type Component = ApplicationHeaderComponent;
	export type Configuration = IApplicationHeaderComponentConfiguration;
}
import manifestXMLSource from './applicationHeader.xml';
import './applicationHeader.scss';

CM.Manager.declare({
	id: 'application-header',
	type: ApplicationHeaderComponent,
	manifest: manifestXMLSource
});
